<template>
  <div class="credit">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    ></SiruiSearch>
    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :row-style="rowStyle"
        :paging="true"
        :reserve="true"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        @chooseClick="chooseClick"
        @currentChange="currentChange"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
        @sortChangeEvent="sortChangeEvent"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :type="item.type"
          :visible="item.visible"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.field === 'accountType'">
              {{ accountsTypeData[scope.row[item.field]] }}
            </span>
            <span v-else-if="item.field === 'creditType'">
              {{ creditTypeData[scope.row[item.field]] }}
            </span>
            <span v-else-if="item.field === 'partnerType'">
              {{ enterprisePropertyData[scope.row[item.field]] }}
            </span>
            <span v-else-if="item.field === 'chargePersonAuthority'">
              {{ chargePersonAuthorityData[scope.row[item.field]] }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <!-- sunxueping 添加批量导入 -->
    <sirui-upload
      :action="action"
      @getData="getData"
      ref="SiruiUpload"
      :data="{ ...token }"
    ></sirui-upload>
    <!-- ====================== -->
  </div>
</template>

<script>
  // import axios from 'axios';
  import { mapState } from 'vuex';
  import API from '@/api/purchaseSalesCenter/credit/credit.js';
  import DataBaseAPI from '@/api/dataBase';
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  import { filterEmpty } from '@/common/js/util';
  import { dateFormatter } from '@/common/js/util';
  import tableMixins from '@/common/mixins/table.js';
  // ============ sunxueping 添加批量导入 ============
  import siruiUpload from '@/components/SiruiUpload';
  // ================================================

  export default {
    mixins: [tableMixins],
    components: {
      SiruiTable,
      SiruiSearch,
      //  sunxueping 添加批量导入
      siruiUpload,
      // =======================
    },
    name: 'creditList',
    data() {
      let routeQuery = this.$route.query || null;
      return {
        //  sunxueping 添加批量导入
        action: API.IMPORT_CREDITLIMITMAINTAIN,
        // =======================
        load: false,
        img: './static/img/tips.png',
        query: {
          partnerType: null,
          controlAreaCode: null,
          validDate: routeQuery && routeQuery.validDate ? routeQuery.validDate : null,
          invalidDate: routeQuery && routeQuery.validDate ? routeQuery.validDate : null,
          partnerName: routeQuery && routeQuery.partnerZhName ? routeQuery.partnerZhName : null,
          creditType: null,
          accountType: null,
        },
        multipleSelection: [], //存放选中的值
        menuButtonList: [],
        tableData: [],
        businessDepartmentList: [], //事业部门下拉列表
        partnerTypeList: [], //合作伙伴类型
        partnerTypeData: [],
        creditTypeList: [], //授信类型下拉列表
        creditTypeData: [],
        accountsTypeData: [],
        enterprisePropertyData: [],
        chargePersonAuthorityData: [],
        accountsTypeList: [], //账款类型下拉列表
        rowData: {}, //被选中的列
        columnList: [],
        //表格显示字段
        columnListDefault: [
          {
            type: 'checkbox',
            visible: true,
            width: '50',
            fixed: 'left',
          },
          {
            field: 'controlAreaName',
            title: 'credit.table.businessDepartmentName',
            //sortable: true,
            visible: true,
          },
          { field: 'partnerType', title: 'credit.table.partnerTypeName', visible: true },
          { field: 'partnerCode', title: 'credit.table.partnerCode', visible: true },
          { field: 'partnerName', title: 'credit.table.partnerName', visible: true },
          { field: 'accountType', title: 'credit.table.accountType', visible: true },
          { field: 'creditType', title: 'credit.table.creditType', visible: true },
          { field: 'creditCode', title: 'credit.table.creditCode', visible: true },
          { field: 'creditCodeDesc', title: 'credit.table.creditCodeDesc', visible: true },
          { field: 'validDate', title: 'credit.table.validDate', visible: true },
          { field: 'invalidDate', title: 'credit.table.invalidDate', visible: true },
          { field: 'requestAmount', title: 'credit.table.requestAmount', visible: true },
          { field: 'currencyTypeName', title: 'credit.table.currencyType', visible: true },
          { field: 'chargePersonAuthority', title: '部门责任人权限', visible: true },
          { field: 'creditPeriod', title: '账期', visible: true },
          { field: 'gmtCreate', title: 'credit.table.gmtCreate', visible: true },
          { field: 'createPersonName', title: 'credit.table.createBy', visible: true },
          { field: 'mark', title: 'credit.table.mark', visible: true },
        ],
      };
    },
    computed: {
      //搜索字段
      searchColumns() {
        return [
          {
            prop: 'partnerType',
            name: this.$t('credit.search.partnerType'),
            type: 'select',
            clearabled: true,
            placeholder: this.$t('credit.search.partnerTypePlaceholder'),
            options: this.partnerTypeList,
          },
          {
            prop: 'controlAreaCode',
            name: this.$t('credit.search.businessDepartment'),
            placeholder: this.$t('credit.search.businessDepartmentPlaceholder'),
            type: 'treeSelect',
            apiUrl: DataBaseAPI.LIST_TREE,
            apiData: {
              tenantCode: this.userInfo.userInfo.tenantCode,
              adminFlag: this.userInfo.userInfo.adminFlag,
              currentStatus: '0',
            },
            clearable: false,
            normalizerFlag: true,
          },
          {
            prop: 'validDate',
            name: this.$t('credit.search.validDate'),
            type: 'startDaterangePicker',
            placeholder: this.$t('credit.search.validDatePlaceholder'),
          },
          {
            prop: 'invalidDate',
            name: this.$t('credit.search.invalidDate'),
            type: 'endDaterangePicker',
            placeholder: this.$t('credit.search.invalidDatePlaceholder'),
          },
          {
            prop: 'partnerName',
            name: this.$t('credit.search.partnerName'),
            type: 'input',
            placeholder: this.$t('credit.search.partnerNamePlaceholder'),
          },
          {
            prop: 'creditType',
            name: this.$t('credit.search.creditType'),
            type: 'select',
            clearabled: true,
            placeholder: this.$t('credit.search.creditTypePlaceholder'),
            options: this.creditTypeList,
          },
          {
            prop: 'accountType',
            name: this.$t('credit.search.accountsType'),
            type: 'select',
            clearabled: true,
            placeholder: this.$t('credit.search.accountsTypePlaceholder'),
            options: this.accountsTypeList,
          },
        ];
      },
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      // sunxueping 添加
      token() {
        return {
          access_token: this.userInfo.userInfo.access_token,
          companyCode: this.userInfo.userInfo.companyCode,
          companyName: this.userInfo.userInfo.companyName,
          departmentCode: this.userInfo.userInfo.departmentCode,
          departmentName: this.userInfo.userInfo.departmentName,
          tenantCode: this.userInfo.userInfo.tenantCode,
        };
      },
    },
    /**页面必要代码Start */
    mounted() {
      this.getData();
      this.getButtonList();
      this.getDic();
    },
    methods: {
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
          this.getColumnInfo();
        });
      },
      //获取当前列
      getColumnInfo() {
        this.getColumnList(this.columnListDefault).then((res) => {
          this.columnList = res;
        });
      },
      //获取字典值
      getDic() {
        let tenantCode = this.userInfo.userInfo.tenantCode;
        //合作伙伴类型
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'partner_type', tenantCode })
          .then((res) => {
            if (0 == res.data.code) {
              this.partnerTypeList = res.data.data;
              for (var item of res.data.data) {
                this.enterprisePropertyData[item['value']] = item['label'];
              }
            }
          });
        //授信类型
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'credit_type', tenantCode })
          .then((res) => {
            if (0 == res.data.code) {
              this.creditTypeList = res.data.data;
              for (var item of res.data.data) {
                this.creditTypeData[item['value']] = item['label'];
              }
            }
          });
        //账款类型
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'account_type', tenantCode })
          .then((res) => {
            if (0 == res.data.code) {
              this.accountsTypeList = res.data.data;
              for (var item of res.data.data) {
                this.accountsTypeData[item['value']] = item['label'];
              }
            }
          });
        //部门责任人权限
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'yes-no', tenantCode })
          .then((res) => {
            if (0 == res.data.code) {
              for (var item of res.data.data) {
                this.chargePersonAuthorityData[item['value']] = item['label'];
              }
            }
          });
      },
      //获取数据
      getData() {
        this.load = true;
        const query = this.$refs.siruiSearch.query;
        query.pageSize = this.$refs.siruiTable.page.pageSize;
        query.pageNum = this.$refs.siruiTable.page.pageNum;
        this.$axios.post(API.APPLICATION_LIST_API, query).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = res.data.data.list;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //行项目样式
      rowStyle({ row }) {
        let newDate = new Date(dateFormatter(new Date()));
        let invalidDate = new Date(row.invalidDate);
        if (invalidDate < newDate) {
          return {
            backgroundColor: '#f0f0f0',
          };
        }
      },
      //表格选中事件
      currentChange(row) {
        if (JSON.stringify(this.rowData) == '{}' || this.rowData.id != row.id) {
          this.rowData = row;
        } else if (this.rowData.id == row.id) {
          this.rowData = {};
        }
      },
      //调用接口排序
      sortChangeEvent({ column, property, order }) {
        console.info(column, property, order);
      },
      //点击按钮触发的方法
      chooseClick(type) {
        //新增
        if (type === 'add') {
          this.add();
        } else if (type === 'del') {
          //删除
          //判断按钮类型--删除
          this.del();
        } else if (type === 'export') {
          //导出
          this.export();
        } else if (type === 'edit') {
          if (JSON.stringify(this.multipleSelection) == '{}') {
            this.$message({
              showClose: true,
              message: this.$t('applicationCredit.msg.notSelectedModify'),
              type: 'error',
            });
          } else {
            let ids = [];
            this.multipleSelection.map((item) => {
              ids.push(item.id);
            });
            let path = {
              path: '/credit/creditEdit',
              name: 'creditEdit',
              meta: {
                keepAlive: true,
                title: this.$t('applicationCredit.msg.creditModification'),
              },
              query: { id: ids },
            };
            this.$store.dispatch('tagsView/addTabView', path).then(() => {
              this.$nextTick(() => {
                this.$router.push(path);
              });
            });
          }
        }
        // ============ sunxueping 添加批量导入 ============
        else if (type == 'import') {
          this.handleImport();
        }
        // ================================================
      },
      // ============ sunxueping 添加批量导入 ============
      handleImport() {
        this.$refs.SiruiUpload.openDialog(true);
      },
      // ================================================
      //新增
      add() {
        let path = {
          path: '/credit/creditAdd',
          name: 'creditAdd',
          meta: {
            keepAlive: true,
            title: this.$t('applicationCredit.msg.newCredit'),
          },
          query: {},
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      //导出
      export() {
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        const query = this.$refs.siruiSearch.query;
        const params = filterEmpty(query);
        params.ids = [];
        if (selectedList.length > 0) {
          selectedList.map((item) => {
            params.ids.push(item.id);
          });
        }
        if (this.multipleSelection.length > 0) {
          this.multipleSelection.map((item) => {
            params.ids.push(item.id);
          });
        }
        // 获取数据
        this.$axios.post(API.EXPORT_APPLICATION_API, filterEmpty(params)).then((res) => {
          if (res.data.code === 0) {
            window.location.href = res.data.data;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //删除
      del() {
        this.$confirmAction()
          .then(() => {
            let ids = [];
            this.multipleSelection.map((item) => {
              ids.push(item.id);
            });
            this.$axios.post(API.DELETE_APPLICATION_API, { ids }).then((res) => {
              if (0 == res.data.code) {
                //如果操作成功，直接返回列表
                this.$message({
                  type: 'success',
                  message: this.$t('message.success'),
                });
                this.getData();
              } else {
                //如果有错误返回，提示信息
                this.$alert(res.data.msg);
              }
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      /**页面必要代码End */
    },
  };
</script>
